import { render } from "./DescLoan.vue?vue&type=template&id=16978718"
import script from "./DescLoan.vue?vue&type=script&lang=js"
export * from "./DescLoan.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__